export enum ModalId {
  TRAVELLER_PANEL = 'travellers-panel',
  EDIT_TRAVELLER_PANEL = 'edit-traveller-panel',
  BOOKING_PANEL = 'booking-panel',
  EDIT_INFO_PANEL = 'edit-info-panel',
}
